import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import type { GetZuubInsuranceDetailResponseV4 } from '../@types/zuub/contracts';

import { makeAPIRequestReactQueryWithHeaders } from './api';
import { endpoints } from './endpoints';

interface UseGetZuubInsuranceDetailParams {
  pmsPatientId: string | undefined;
  enabled?: boolean;
}

export const useGetZuubInsuranceDetail = ({
  pmsPatientId,
  enabled = true,
}: UseGetZuubInsuranceDetailParams) => {
  const {
    primaryPracticeId: practiceId,
    primaryOrganizationId: organizationId,
  } = useSelector((state: any) => state.login.user);

  return useQuery(
    [endpoints.zuubInsuranceDetailV4, pmsPatientId],
    () => {
      return makeAPIRequestReactQueryWithHeaders<GetZuubInsuranceDetailResponseV4>(
        `${endpoints.zuubInsuranceDetailV4}/${pmsPatientId}`,
        {},
        {
          Org: organizationId,
          Practice: practiceId,
        },
        'GET',
      );
    },
    {
      enabled: enabled && !!pmsPatientId,
      staleTime: 5 * 60 * 1000,
      cacheTime: 10 * 60 * 1000,
    },
  );
};
